// src/components/studentPortal/Tools.jsx
// Section 6 of the Student Portal. Pure reuse per the owner's instruction -
// StudentToolLinks.jsx (PLAN S11b) is rendered completely unmodified.
//
// Known wrinkle, flagged not fixed: StudentToolLinks' "Start a new project"
// and "My projects" buttons navigate to the old standalone /starter and
// /myprojects routes (outside this single-URL portal), rather than jumping
// to this portal's own MyProjects section. Left as-is to avoid touching
// already-shipped S11b code without being asked.
import React from 'react';
import StudentToolLinks from '../StudentToolLinks';

const Tools = () => (
  <div>
    <h2 className="text-xl font-bold text-slate-800 mb-4">Tools</h2>
    <StudentToolLinks />
  </div>
);

export default Tools;
